import { cx } from '#shared/cx';

interface Props {
  confirmationMessage?: string;
  setConfirmationMessage?: (message: string) => void;
  errorMessage?: string;
  setErrorMessage?: (message: string) => void;
  customContainerStyle?: React.CSSProperties;
  customTextStyle?: React.CSSProperties;
  errorIcon?: boolean;
  confirmationIcon?: boolean;
  applyGridLayout?: boolean;
}

const NotificationContainer = ({
  confirmationMessage,
  setConfirmationMessage,
  errorMessage,
  setErrorMessage,
  customContainerStyle,
  customTextStyle,
  errorIcon = true,
  confirmationIcon = true,
  applyGridLayout = true,
}: Props) => {
  return (
    <div id="notification-container" style={customContainerStyle}>
      {errorMessage && (
        <div id="error-area" className={cx('error-alert', applyGridLayout && 'col-md-12')}>
          <div className="alert alert-danger fade in red-alert">
            {errorIcon && <i className="fas fa-minus-circle" />}
            <button type="button" className="close" data-hide="error-alert" onClick={() => setErrorMessage?.('')}>
              <span aria-hidden="true">&times;</span>
              <span className="sr-only">Close</span>
            </button>
            <strong>
              <span id="error-message" style={customTextStyle}>
                {errorMessage}
              </span>
            </strong>
          </div>
        </div>
      )}
      {confirmationMessage && (
        <div id="confirmation-area" className={cx('confirmation-alert', applyGridLayout && 'col-md-12')}>
          <div className="alert alert-success fade in green-alert">
            {confirmationIcon && <i className="far fa-check-circle" />}
            <button
              type="button"
              className="close"
              data-hide="confirmation-alert"
              onClick={() => setConfirmationMessage?.('')}
            >
              <span aria-hidden="true">&times;</span>
              <span className="sr-only">Close</span>
            </button>
            <strong>
              <span id="confirmation-message" style={customTextStyle}>
                {confirmationMessage}
              </span>
            </strong>
          </div>
        </div>
      )}
    </div>
  );
};

export default NotificationContainer;
